require('./../scss/main.scss');

// JavaScript Document
window.is_search_page = false;
var isTouch = (("ontouchstart" in window) || (navigator.msMaxTouchPoints > 0));
// BEGIN old scripts: not sure if we still need them
window.mobile = false;

function readCookie(name) {
	var nameEQ = name + "=";
	var ca = document.cookie.split(';');
	for(var i=0;i < ca.length;i++) {
		var c = ca[i];
		while (c.charAt(0)==' ') c = c.substring(1,c.length);
		if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length,c.length);
	}
	return null;
}
// END old scripts


//Breaks optimizely commenting out 8-26-2016 to be deleted after 9-26-2016
// if( self != top ) { top.location.href = self.location.href; }


function addPlaceholders(){
	if(!Modernizr.input.placeholder){
		jQuery('[placeholder]').focus(function() {
			var input = jQuery(this);
			if (input.val() == input.attr('placeholder'))
				input.val('').removeClass('placeholder');
		}).blur(function() {
			var input = jQuery(this);
			if (input.val() === '' || input.val() === input.attr('placeholder'))
				input.addClass('placeholder').val(input.attr('placeholder'));
			else
				input.removeClass('placeholder');
		}).blur();
		jQuery('[placeholder]').parents('form').submit(function() {
			jQuery(this).find('[placeholder]').each(function() {
				var input = jQuery(this);
				if (input.val() == input.attr('placeholder'))
					input.val('');
			});
		});
	}
}
function removePlaceholders(){
	if(!Modernizr.input.placeholder){
		jQuery('[placeholder]').each(function() {
			if (jQuery(this).val() == jQuery(this).attr('placeholder'))
				jQuery(this).val('');
		});
	}
}
var social_loaded = false;
function load_social(){
	if(!social_loaded){
		//Facebook JS
		(function(d, s, id) {
		  var js, fjs = d.getElementsByTagName(s)[0];
		  if (d.getElementById(id)) return;
		  js = d.createElement(s); js.id = id;
		  js.src = "//connect.facebook.net/en_US/all.js#xfbml=1";
		  fjs.parentNode.insertBefore(js, fjs);
		}(document, 'script', 'facebook-jssdk'));

		//Twitter JS
		!function(d,s,id){var js,fjs=d.getElementsByTagName(s)[0],p=/^http:/.test(d.location)?'http':'https';if(!d.getElementById(id)){js=d.createElement(s);js.id=id;js.src=p+'://platform.twitter.com/widgets.js';fjs.parentNode.insertBefore(js,fjs);}}(document, 'script', 'twitter-wjs');

		//Pinterest JS
		(function(d){
			var f = d.getElementsByTagName('SCRIPT')[0], p = d.createElement('SCRIPT');
			p.type = 'text/javascript';
			p.async = true;
			p.src = '//assets.pinterest.com/js/pinit.js';
			f.parentNode.insertBefore(p, f);
		}(document));

		//Google + JS
		(function() {
			var po = document.createElement('script'); po.type = 'text/javascript'; po.async = true;
			po.src = '//apis.google.com/js/platform.js';
			var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(po, s);
		})();
		social_loaded = true;
	}
}
jQuery( document ).ready(function(){
	addPlaceholders();
	jQuery("#topnav li.has-submenu").hover(function(){
		//alert(jQuery(this).width());
		jQuery(this).addClass('hover');
	},
	function(){
		jQuery(this).removeClass('hover');
	});
    jQuery(".mod-list").on("click", '.favorite-btn', function() {
        var favUnitID = jQuery(this).attr("id");
		jQuery.post("/unit/" + favUnitID, {process:"favorite"}, function(data){
			if(data.favorite){
				title_txt = "Remove this rental from your favorites";
				jQuery(".favorite-btn" + "#" + favUnitID + " .icon-btn").removeClass("icon-btn-favorite").addClass("icon-btn-favorite-active");
			} else {
				title_txt = "Add this rental to your favorites";
				jQuery(".favorite-btn" + "#" + favUnitID + " .icon-btn").removeClass("icon-btn-favorite-active").addClass("icon-btn-favorite");
			}
			jQuery(".favorite-btn" + "#" + favUnitID + " .icon-btn").attr("title", title_txt).tooltip( "option", "content", title_txt );
		}, "json");
	});
	// this tooltip plugin was chained to the previous item
	// but caused tooltips to show up for every listing title and other places throughout the site
	// not sure if it's being used right now
	// note that I don't think it will be applied to refreshed listings as is, only listings on page load
	jQuery(".mod-list .favorite-btn").tooltip({
		position: {
			my: "center bottom",
			at: "center top-20",
			using: function( position, feedback ) {
			  jQuery( this ).css( position );
			  jQuery( "<div>" )
				.addClass( "tooltip-arrow" )
				.addClass( feedback.vertical )
				.addClass( feedback.horizontal )
				.appendTo( this );
			}
		},
		hide : false
	});
	jQuery("#menu-item-social.has-submenu").hover(function(){
        load_social();
    });

	var flyout = {

		speed : 250,

		close : function(){
			jQuery("#content-click").hide();
			jQuery("#content").animate({
				left: "0px"
			}, 250, "swing", function(){
				jQuery("#flyout-menu").hide();
			});
		},

		open : function(){
			jQuery("#content-click, #flyout-menu").show();
			jQuery("#content").animate({
				left: "250px"
			}, 250);
		},

		init : function(){
			var self = this;
			jQuery("#menu-item-menu a").click(function(e) {
				e.preventDefault();
				self.open();
			});
			jQuery("#content-click").click(function(e) {
				self.close();
			});
			if(isTouch){
				jQuery("#content-click").swipe( {
					swipeStatus:function(event, phase, direction, distance, duration)
					{
						if (phase == "move" && direction == "left") {
							jQuery("#content").css(direction, (250 - distance) + "px");
						} else if (phase == "cancel") {
							self.open();
						} else if (phase == "end") {
							if (direction == "left") {
								self.close();
							} else {
								self.open();
							}
						}
					},
					triggerOnTouchEnd: true,
					threshold: 75,
					allowPageScroll : "none",
					excludedElements : ""
				});
			}
		}
	};

	flyout.init();

	jQuery(".nav-select select").change(function(e) {
		var txt = jQuery(this).find("option:selected").text();
		var url = jQuery(this).find("option:selected").val();
		//if(txt=='') txt = jQuery(this).data('default');
		jQuery(this).siblings('.nav-select-display').text(txt);
		window.location = url;
	});

	// handle listing overflow
	jQuery(".listing-overflow").each(function(){
		var outer, inner, btn;
		outer = jQuery(this).find('.text-overflow-content').height();
		inner = jQuery(this).find('.text-overflow-content-inner').height();
		btn = jQuery(this).find('.text-overflow-btn');
		if(inner > outer){
			btn.addClass('text-overflow-btn-closed');
		}
	});

	function QueryStringToJSON(string) {
		var pairs = string.split('&');

		var result = {};
		pairs.forEach(function(pair) {
			pair = pair.split('=');
			result[pair[0]] = decodeURIComponent(pair[1] || '');
		});

		return JSON.parse(JSON.stringify(result));
	}

	// handle loaded page with hash search
	if(location.hash.length > 1 && location.hash.search("submit=Search")>=0){
		var hash = window.location.hash.substring(1);
		var path = window.location.protocol.replace(":","") + "://" + window.location.hostname;
		if(is_search_page === true)
			path += window.location.pathname + '?';
		else
			path += '/search/?';
		window.location = path + hash;
	}
});



// Loading Animation
var cSpeed=12;
var cWidth=128;
var cHeight=128;
var cTotalFrames=12;
var cFrameWidth=128;
var cImageSrc='/images/loading.png';

var cImageTimeout=false;
var cIndex=0;
var cXpos=0;
var cPreloaderTimeout=false;
var SECONDS_BETWEEN_FRAMES=0;

function createLoader(element){
    clearTimeout(cImageTimeout);
    cImageTimeout=1000;
    jQuery( document ).ready(function(){
        jQuery(element).css('position','relative').prepend('<div class="loader"><div class="loader-img-outer"><div class="loader-img-inner"></div></div></div>');
    });
    //FPS = Math.round(100/(maxSpeed+2-speed));
    FPS = Math.round(360/cSpeed);
    SECONDS_BETWEEN_FRAMES = 1 / FPS;
}

function startLoader(element){
    cXpos += cFrameWidth;
    //increase the index so we know which frame of our animation we are currently on
    cIndex += 1;

    //if our cIndex is higher than our total number of frames, we're at the end and should restart
    if (cIndex >= cTotalFrames) {
        cXpos =0;
        cIndex=0;
    }

    loader = element + ' .loader';
    loaderImg = element + ' .loader-img-inner';
    jQuery(loaderImg).css('background-position', (-cXpos)+'px 0');
    jQuery(loader).show();

    cPreloaderTimeout=setTimeout('startLoader("'+element+'")', SECONDS_BETWEEN_FRAMES*1000);
}

function pauseLoader(element){//stops animation
	jQuery(element + ' .loader').hide();
	clearTimeout(cPreloaderTimeout);
	cPreloaderTimeout=false;
}

function imageLoader(s, fun)//Pre-loads the sprites image
{
	clearTimeout(cImageTimeout);
	cImageTimeout=1000;
	genImage = new Image();
	genImage.onload=function (){ cImageTimeout=setTimeout(fun, 0); };
	//genImage.onerror=new Function('alert(\'Could not load the image\')');
	genImage.src=s;
}
// end of Loading Animation code

// Touch event for iphone safari
jQuery(window).on("touchstart", function(ev) {
});

/**
 * Maintenance Banner
 */
jQuery( document ).ready(function(){
	var banner;
	
	if (storageAvailable('localStorage')) {
		banner = window.sessionStorage.getItem("bannerMaintenance");
		
		// If session is nope or banner doesn't exists, don't add banner class, else add it.
		if(banner === 'nope' || $("#banner-maintenance").length == 0) {
			$("body").removeClass("banner");
		} else {
			$("body").addClass("banner");
		}
	}
	
	$("#banner-dismiss").on("click", function() {
		if (storageAvailable('localStorage')) {
			window.sessionStorage.setItem("bannerMaintenance", 'nope');
		}
		
		$("body").removeClass("banner");
	});
});

/**
 * Local Storage checker
 */
function storageAvailable(type) {
    try {
        var storage = window[type],
            x = '__storage_test__';
            storage.setItem(x, x);
            storage.removeItem(x);
            return true;
    } catch (e) {
		console.log("not writeable");
        return false;
    }
}

window.createLoader = createLoader;
window.startLoader = startLoader;
window.pauseLoader = pauseLoader;
window.imageLoader = imageLoader;
window.removePlaceholders = removePlaceholders;
window.addPlaceholders = addPlaceholders;
window.load_social = load_social;
window.storageAvailable = storageAvailable;


//////////////////
// WEBPACK FOOTER
// ./src/js/general.js
// module id = 2
// module chunks = 1